// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"4ee6845d","210":"a829420f","424":"436a3a43","591":"7a5188f0","722":"a276a4b3","763":"f705d888","905":"c39c916c"}[chunkId] + ".chunk.js";
};